import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';
import initializeVdrClient from 'scaleflow/utils/aws-clients/s3VDRClient';

class RoadmapTableInitiativeRoute extends Route {
  @service store;
  @service router;
  @service tracker;
  @service chatv2;
  @service session;
  @service betaToggle;
  @service organisation;

  beforeModel() {
    const idToken = this.session.idToken;
    if (!idToken) this.router.transitionTo('login');
    else {
      const promises = [
        this.store.findAll('team'),
        this.store.findAll('goal'),
        this.store.findAll('theme'),
        this.store.findAll('person'),
        this.store.findAll('role'),
        this.store.findAll('metric'),
        this.store.findAll('investment-scenario'),
        this.store.findAll('agent'),
      ];
      if (this.betaToggle.showAiFeatures)
        promises.push(initializeVdrClient(this.store).catch(() => null));

      return RSVP.all(promises);
    }
  }

  model(params) {
    return this.store
      .findRecord('initiative', `${params.initiative}`, {
        include: 'conversations',
        reload: true,
      })
      .catch((err) => {
        if (err?.errors?.[0]?.status === '404') {
          this.router.transitionTo('backlog.initiatives');
          return;
        }
        throw err;
      });
  }

  async afterModel(model) {
    if (!model) return;
    this.tracker.trackInitiativeOpenedEvent(model.id);
    await this.store.findAll('conversation', { reload: true });
    // await this.chatv2.populateChatWindow();
  }

  resetController(controller, isExiting, transition) {
    if (isExiting) {
      this.chatv2.toggleChatWindow(false);
    }
    super.resetController(controller, isExiting, transition);
  }
}

export default instrumentRoutePerformance(RoadmapTableInitiativeRoute);
